export const TEACHER_CODE_ACCESS_STORAGE_KEY = "teacherCodeAccess";

// 1.5 hours
export const TEACHER_CODE_SESSION_DURATION_MS = 90 * 60 * 1000;

function canUseSessionStorage() {
  return (
    typeof window !== "undefined" &&
    typeof window.sessionStorage !== "undefined"
  );
}

function isPositiveNumber(value) {
  return typeof value === "number" && Number.isFinite(value) && value > 0;
}

export function normalizeClassCode(value) {
  return typeof value === "string" ? value.trim().toUpperCase() : "";
}

export function createTeacherCodeAccessSession({
  groupId = "",
  classCode = "",
  groupName = "",
  durationMs = TEACHER_CODE_SESSION_DURATION_MS,
} = {}) {
  const safeGroupId = typeof groupId === "string" ? groupId.trim() : "";
  const safeClassCode = normalizeClassCode(classCode);
  const safeGroupName = typeof groupName === "string" ? groupName.trim() : "";

  const safeDurationMs = isPositiveNumber(durationMs)
    ? durationMs
    : TEACHER_CODE_SESSION_DURATION_MS;

  const createdAt = Date.now();
  const expiresAt = createdAt + safeDurationMs;

  return {
    type: "teacher-code",
    groupId: safeGroupId,
    classCode: safeClassCode,
    groupName: safeGroupName,
    createdAt,
    expiresAt,
  };
}

export function isTeacherCodeAccessValid(sessionData) {
  if (!sessionData || typeof sessionData !== "object") return false;
  if (sessionData.type !== "teacher-code") return false;

  const classCode = normalizeClassCode(sessionData.classCode);

  if (!classCode) return false;
  if (!isPositiveNumber(sessionData.createdAt)) return false;
  if (!isPositiveNumber(sessionData.expiresAt)) return false;
  if (sessionData.expiresAt <= sessionData.createdAt) return false;
  if (sessionData.expiresAt <= Date.now()) return false;

  return true;
}

export function setTeacherCodeAccess(sessionInput) {
  if (!canUseSessionStorage()) return null;

  const sessionData = createTeacherCodeAccessSession(sessionInput);

  window.sessionStorage.setItem(
    TEACHER_CODE_ACCESS_STORAGE_KEY,
    JSON.stringify(sessionData)
  );

  return sessionData;
}

export function getTeacherCodeAccess() {
  if (!canUseSessionStorage()) return null;

  try {
    const rawValue = window.sessionStorage.getItem(
      TEACHER_CODE_ACCESS_STORAGE_KEY
    );

    if (!rawValue) return null;

    const parsedValue = JSON.parse(rawValue);

    if (!isTeacherCodeAccessValid(parsedValue)) {
      window.sessionStorage.removeItem(TEACHER_CODE_ACCESS_STORAGE_KEY);
      return null;
    }

    return parsedValue;
  } catch (error) {
    console.error("Invalid teacher code access session:", error);
    window.sessionStorage.removeItem(TEACHER_CODE_ACCESS_STORAGE_KEY);
    return null;
  }
}

export function clearTeacherCodeAccess() {
  if (!canUseSessionStorage()) return;
  window.sessionStorage.removeItem(TEACHER_CODE_ACCESS_STORAGE_KEY);
}

export function getTeacherCodeRemainingMs() {
  const sessionData = getTeacherCodeAccess();

  if (!sessionData) return 0;

  return Math.max(sessionData.expiresAt - Date.now(), 0);
}